import React from "react";
import styles from "./UserMessage.module.css";
import {ChatHistoryDTO} from "../../../../../../../api/generated";
import {MessageTime} from "../messageTime/MessageTime";
import {TextInMarkdown} from "../../../../../../elements/textInMarkdown/TextInMarkdown";

interface UserMessageProps {
    chatHistory: ChatHistoryDTO
}

export const UserMessage: React.FC<UserMessageProps> = ({
                                                            chatHistory
                                                        }) => {

    return <div className={styles.wrapper}>
        <TextInMarkdown/>
        <span className={styles.messageContent}>
            <TextInMarkdown text={chatHistory.message}/>
        </span>
        <MessageTime timestamp={chatHistory.timestamp}/>
    </div>
}
